import React from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="profile-page">
      <div 
        className="profile-header" 
        style={{ 
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/branding/hero-fashion.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="profile-avatar">
          <span className="profile-avatar-text">
            {user?.username?.charAt(0).toUpperCase() || 'U'}
          </span>
        </div>
        <h2 className="profile-name">{user?.username || 'User'}</h2>
        <p className="profile-email">{user?.email || ''}</p>
      </div>

      <div className="profile-menu">
        <div className="profile-menu-section">
          <h3 className="profile-menu-title">Account</h3>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">👤</span>
            <span className="profile-menu-text">Edit Profile</span>
            <span className="profile-menu-arrow">›</span>
          </button>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">🔔</span>
            <span className="profile-menu-text">Notifications</span>
            <span className="profile-menu-arrow">›</span>
          </button>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">🔒</span>
            <span className="profile-menu-text">Privacy</span>
            <span className="profile-menu-arrow">›</span>
          </button>
        </div>

        <div className="profile-menu-section">
          <h3 className="profile-menu-title">Preferences</h3>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">🎨</span>
            <span className="profile-menu-text">Theme</span>
            <span className="profile-menu-arrow">›</span>
          </button>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">🌐</span>
            <span className="profile-menu-text">Language</span>
            <span className="profile-menu-arrow">›</span>
          </button>
        </div>

        <div className="profile-menu-section">
          <h3 className="profile-menu-title">Support</h3>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">❓</span>
            <span className="profile-menu-text">Help Center</span>
            <span className="profile-menu-arrow">›</span>
          </button>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">📧</span>
            <span className="profile-menu-text">Contact Us</span>
            <span className="profile-menu-arrow">›</span>
          </button>
          <button className="profile-menu-item">
            <span className="profile-menu-icon">ℹ️</span>
            <span className="profile-menu-text">About</span>
            <span className="profile-menu-arrow">›</span>
          </button>
        </div>

        <button className="logout-button" onClick={handleLogout}>
          <span className="logout-icon">🚪</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default ProfilePage;
